import React, {Component} from 'react';
import {connect} from 'react-redux';
import StepControlButton, {CONTROL_NEXT, CONTROL_PREV} from "../../components/navigation/StepControlButton";
import PriceListingRow from "../../components/PriceListingRow";
import {getAccounts, getArticleOptionsData, getContracts, getToggleSelections} from "../../selectors/SimpleSelectors";
import {ToggleSelection, ToggleSelectionButtons, ToggleSelectionContents} from "../util/ToggleSelection";
import ToggleButton, {THEME_BLOCK_DESCRIPTION} from "../../components/ToggleButton";
import {faLayerGroup} from "@fortawesome/pro-light-svg-icons/faLayerGroup";
import {isOutsourcingTargetStepValid} from "../../selectors/StepValidation";
import {forceValidationOnSteps} from "../../actions/StepControl";
import * as StepLabels from "../../constants/StepLabels";
import FloatingContent from "../../components/FloatingContent";
import {getAgencyServerResellers} from "../../selectors/Resellers";
import {queryAddInitialProject, setInitialConfigurationByState} from "../../actions/ProjectSelection";
import {putFormData} from "../../actions/FormData";
import {undoStepCompletion} from "../../actions/UserInterface";
import {ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION, ARTICLE_CONFIGURATOR_MODE_SHARED, OUTSOURCING_ADDPROJECT, OUTSOURCING_CREATE_NEW} from "../../constants/General";
import {delve} from "../../util/util";
import ArticleConfigurator from "../configuration/configurator/ArticleConfigurator";
import {getCurrentProduct} from "../../selectors/ProductSelection";
import StepValidationErrors from "../../components/StepValidationErrors";
import {getCurrentAccountByContract} from "../../selectors/Accounts";
import FadingTransitionGroup from "../../components/FadingTransitionGroup";
import {getContractByParamOrAccount} from "../../selectors/Contract";

function mapStateToProps(state) {

    const contracts = getContracts(state)
    const contractIdentifier = getContractByParamOrAccount(state);

    return {
        articleOptionsData: getArticleOptionsData(state),
        accounts: getAccounts(state),
        currentProduct: getCurrentProduct(state),
        agencyResellers: getAgencyServerResellers(state),
        outsourcingTargetStepValid: isOutsourcingTargetStepValid(state),
        forcedValidationSteps: state.ui.forcedValidationSteps,
        currentAccount: getCurrentAccountByContract(state),
        toggleSelections: getToggleSelections(state),
        contract: contracts ? contracts[contractIdentifier] : null,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        forceValidation: () => {
            dispatch(forceValidationOnSteps([ownProps.stepLabel]))
        },
        initializeConfiguratorByState: (target) => {
            dispatch(setInitialConfigurationByState(target));
        },
        addInitialProject: (selectBase) => {
            dispatch(queryAddInitialProject(selectBase));
        },
        queryFormData: () => {
            dispatch(putFormData())
        },
        undoConfigCompleted: () => {
            dispatch(undoStepCompletion(StepLabels.OUTSOURCING_CONFIG));
            dispatch(undoStepCompletion(StepLabels.OUTSOURCING_AGENCY));
        }
    };
}

class OutsourcingTargetStep extends Component {

    handleButtonNextClick = (e) => {

        if (this.props.outsourcingTargetStepValid === true) {
            this.props.onButtonNextClick()
        } else {
            this.props.forceValidation()
        }
    }

    render() {

        const {accounts, currentProduct, currentAccount} = this.props;

        const accountData = accounts[currentAccount] ? accounts[currentAccount] : {};
        const currentResellerId = "" + delve(accountData, 'reseller.uid');
        const currentArticleData = accountData.article ? this.props.articleOptionsData[accountData.article.articleNumber] : null;

        const stats = accountData && accountData.stats;

        const currentPrice = this.props.contract ? Number(delve(this.props.contract, "contractPrice")).toFixed(2) + " €" : (currentArticleData ? Number(delve(currentArticleData, "price.default.net")).toFixed(2) + " €" : "");

        return (
            <div className="step-display__page outsourcing-target-step">

                <StepValidationErrors
                    stepLabel={StepLabels.OUTSOURCING_TARGET}
                    validationResult={this.props.outsourcingTargetStepValid}
                />

                <h1>Projekt ausgliedern</h1>
                <PriceListingRow
                    monthly={currentArticleData ? delve(currentArticleData, "billing.billingPeriod") !== 0 : null}
                    price={currentPrice}
                    title={"Projekt " + accountData.description + (currentArticleData ? " (" + currentArticleData.title + ")" : "")}
                    caption={accountData.name + ", belegter Speicherplatz: " + Number(stats.summary / 1024 / 1024).toFixed(2) + " GB"}
                />
                <div className={"outsourcing-target-step__target-selection"}>
                    <h2>Ziel der Ausgliederung</h2>
                    <ToggleSelection
                        id="outsourcingTarget"
                        onSelect={(target, oldTarget) => {
                            this.props.initializeConfiguratorByState(target);
                            if (!oldTarget) {
                                this.props.addInitialProject(true);
                            }
                        }}
                    >
                        <ToggleSelectionButtons>
                            <ToggleButton
                                disabled={false}
                                icon={faLayerGroup}
                                target={OUTSOURCING_CREATE_NEW}
                                buttonLabel="Eigenständiges Hosting Paket"
                                theme={THEME_BLOCK_DESCRIPTION}
                                description="Dein Projekt wird in einen eigenständigen CMS- oder Shop-Hosting Tarif ausgegliedert."
                                hint={"ab 15.00 € mtl.*"}
                            />
                            <ToggleButton
                                disabled={Object.keys(this.props.agencyResellers).length === 0}
                                icon={faLayerGroup}
                                target={OUTSOURCING_ADDPROJECT}
                                buttonLabel="Dein Agentur-Server"
                                theme={THEME_BLOCK_DESCRIPTION}
                                description="Dein Projekt wandert als zusätzliches Projekt auf deinen Agentur-Server."
                                hint={"ab 4.00 € mtl.*"}
                                disabledTooltip={"Buche zunächst einen Agentur-Server, um Projekte dann in diesen auszugliedern."}
                            />
                        </ToggleSelectionButtons>

                        <ToggleSelectionContents>
                            <FloatingContent
                                key={OUTSOURCING_CREATE_NEW}
                                align={"left"}
                            >
                                <h3 className={"outsourcing-target-step__target-selection__title"}>Wähle deinen Tarif</h3>
                            </FloatingContent>
                            <FloatingContent
                                key={OUTSOURCING_ADDPROJECT}
                                align={"right"}
                            >
                                <h3 className={"outsourcing-target-step__target-selection__title"}>In welchen Agentur-Server soll das Projekt ausgegliedert werden?</h3>
                                <ToggleSelection
                                    id={"outsourcingResellerTarget"}
                                    onSelect={(target) => {
                                        this.props.queryFormData()
                                    }}
                                >
                                    <ToggleSelectionButtons>
                                        {Object.keys(this.props.agencyResellers).map(resellerId => {
                                            const resellerData = this.props.agencyResellers[resellerId];
                                            return (
                                                <ToggleButton
                                                    key={resellerId}
                                                    buttonLabel={resellerData.name}
                                                    target={resellerId}
                                                    disabled={currentResellerId === resellerId}
                                                    disabledTooltip={"Eine Ausgliederung in denselben Agentur-Server ist nicht möglich."}
                                                />
                                            )
                                        })}
                                    </ToggleSelectionButtons>
                                </ToggleSelection>

                            </FloatingContent>
                        </ToggleSelectionContents>
                    </ToggleSelection>
                    <FadingTransitionGroup>
                        {this.props.toggleSelections["outsourcingTarget"] ? <ArticleConfigurator
                            mode={this.props.toggleSelections["outsourcingTarget"] === OUTSOURCING_CREATE_NEW ? ARTICLE_CONFIGURATOR_MODE_CONSUMER_SELECTION : ARTICLE_CONFIGURATOR_MODE_SHARED}
                            currentProduct={currentProduct}
                            updateSelectedArticle={true}
                            hidePersonalization={true}
                        /> : null}
                    </FadingTransitionGroup>

                </div>
                <div className="step-display__page__control">
                    {this.props.prevLabel !== "" ? <StepControlButton
                        type={CONTROL_PREV}
                        label={this.props.prevLabel}
                        onClick={this.props.onButtonPrevClick}
                    /> : null}
                    {this.props.nextLabel !== "" ? <StepControlButton
                        disabled={this.props.outsourcingTargetStepValid !== true}
                        type={CONTROL_NEXT}
                        label={this.props.nextLabel}
                        onClick={this.handleButtonNextClick}
                    /> : null}
                </div>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OutsourcingTargetStep);



/** WEBPACK FOOTER **
 ** ./src/containers/outsourcing/OutsourcingTargetStep.js
 **/